import { render, staticRenderFns } from "./OfferEvaluationPageCustomerOrderDetails.vue?vue&type=template&id=624df4be&"
import script from "./OfferEvaluationPageCustomerOrderDetails.vue?vue&type=script&lang=ts&"
export * from "./OfferEvaluationPageCustomerOrderDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('624df4be')) {
      api.createRecord('624df4be', component.options)
    } else {
      api.reload('624df4be', component.options)
    }
    module.hot.accept("./OfferEvaluationPageCustomerOrderDetails.vue?vue&type=template&id=624df4be&", function () {
      api.rerender('624df4be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/OfferEvaluationPageCustomerOrderDetails.vue"
export default component.exports